import { tryCatch } from '@thalesrc/js-utils';

import HSApi from '../HSApi';
import { GetWorkingRestrictionDefinitionsResult } from './get-working-restriction-definitions.result';

export async function getWorkingRestrictionDefinitions(): Promise<GetWorkingRestrictionDefinitionsResult[]> {
  const [error, res] = await tryCatch(
    HSApi.get<GetWorkingRestrictionDefinitionsResult[]>(`/firms/hs-exam-working-restriction-definitions`)
  );

  if (error) {
    // tslint:disable-next-line:no-console
    console.error(error);

    throw error;
  }

  return res.data;
}
